export const Features = {
    myPages: 'my-pages',
    administationPages: 'administration-pages',
    customerSupportPages: 'customer-support-pages',
    cleaningAdministrationPages: 'cleaning-administration-pages',
    administrateUsers: 'administrate-users',
    impersonateUsers: 'impersonate-users',
    viewSubscriptions: 'view-subscriptions',
    editSubscriptions: 'edit-subscriptions',
    cancelSubscription: 'cancel-subscription',
    viewMyStorages: 'view-my-storages',
    editMyStorages: 'edit-my-storages',
    unlockMyStorages: 'unlock-my-storages',
    unlockStorages: 'unlock-storages',
    turnOnLight: 'turn-on-light',
};
export function hasPermission(feature, user) {
    if (user === undefined || user === null || !user.role || !user.role.features) {
        return false;
    }
    return user.role.features.some(x => x.id === feature);
}
